import { css } from '@emotion/css';

export const privacyTitle = css`
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  margin-top: 25px;
  margin-bottom: 35px;
  color: #00acf0;
`;

export const privacyContent = css`
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--colors-neutral-80);
  text-align: justify;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ol {
    margin-top: 0;

    li:not(:last-child) {
      margin-bottom: 8px;
    }
  }
`;

export const privacyLink = css`
  color: #00acf0;
`;

export const privacyButton = css`
  text-align: center;
  background-color: #fff !important;
  padding: 20px;

  button {
    text-transform: none !important;
    padding: 0;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
  }

  button.submit:not(.Mui-disabled) {
    color: #00acf0;
  }
`;

export const floatingChip = css`
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.16);
  border-radius: 100px;
  border: 1px solid #83a7fa;
  background: #eaf0fe;
  color: #306cf7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  position: fixed;
  bottom: 90px;
  width: auto;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  user-select: none;
`;

export const arrowCss = (reversed = false) => css`
  margin-right: 4px;
  transform: rotate(${reversed ? '180deg' : '0'});
`;

export const privacyFooterAction = css`
  position: fixed;
  left: 0;
  bottom: 0px;
  left: 0px;
  width: 100%;
  border-top: 1px solid #cccccc;
  right: 0;
  max-width: 550px;
  margin: auto;
`;
